import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import IntroduccionPage from "./pages/IntroduccionPage";
import TestPage from "./pages/TestPage";
import ResultadosPage from "./pages/ResultadosPage";
import BibliotecaPage from "./pages/BibliotecaPage";
import ArquetipoDetallePage from "./pages/ArquetipoDetallePage";
import Layout from "./components/Layout";
import "./App.css";

function App() {
  return (
    <div className="App min-h-screen bg-[#0F0518]">
      <BrowserRouter>
        <Toaster 
          position="top-center" 
          richColors 
          toastOptions={{
            style: {
              background: 'rgba(26, 11, 46, 0.95)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              color: '#F3E5F5',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="introduccion" element={<IntroduccionPage />} />
            <Route path="test" element={<TestPage />} />
            <Route path="resultados/:resultadoId" element={<ResultadosPage />} />
            <Route path="resultados" element={<ResultadosPage />} />
            <Route path="biblioteca" element={<BibliotecaPage />} />
            <Route path="arquetipo/:arquetipoId" element={<ArquetipoDetallePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
